import React, { Component, createRef } from "react";
import { POST, loading, token, alert } from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      package_type: "package",
    };
  }
  componentDidMount() {
    loading(false);
  }
  Submit = (name, price) => {
    window.location.href = "/contact?subject=package:" + name;
  };
  render() {
    const { package_type } = this.state;
    return (
      <div className="w-100 min-vh-100 background position-relative">
        <Navbar />
         {/* SECTION 1 */}
        <div className="w-100 bg-blue text-white align-content-center">
          <div className="container mx-auto px-4 text-center py-5">
            <div className="my-5">
              <h1 className="fw-bold mb-4">บริการพัฒนาซอฟต์แวร์</h1>
              <h5 className="mb-3">แพ็คเกจที่ปรับแต่งได้ตามความต้องการของธุรกิจคุณ</h5>
              <a className="btn btn-light px-4" href="/contact?subject=ปรึกษาแพ็คเกจที่เหมาะสม">ปรึกษาแพ็คเกจที่เหมาะสม</a>
            </div>
          </div>
        </div>
        {/* SECTION 2 */}
        <div className="w-100 bg-white align-content-center py-5">
          <div className="d-flex justify-content-center mb-4">
            <div className="rounded-4 bg-light p-1 d-flex">
              <button
                className={`btn ${package_type === "package" ? "btn-primary" : "btn-outline-primary border-0"} wpx-180 me-1`}
                onClick={() => {
                  this.setState({ package_type: "package" });
                }}
              >
                แพ็คเกจหลัก
              </button>
              <button
                className={`btn ${package_type === "month" ? "btn-primary" : "btn-outline-primary border-0"} wpx-180 ms-1`}
                onClick={() => {
                  this.setState({ package_type: "month" });
                }}
              >
                แพ็คเกจรายเดือน
              </button>
            </div>
          </div>
          {package_type === "package" && (
            <div className="row container mx-auto">
              <div className="col-12 col-md-6 col-xl-3 mb-3 p-1">
                <div className="card card-dashboard mx-auto bg-white rounded-4 bg-white p-4">
                  <div className="text-center">
                  <h5 className="fw-bold">Starter</h5>
                  <h2 className="fw-bold mb-0 mx-2 mb-2">25,000</h2>
                  <div className="mb-2 hpx-50 text-14 text-secondary">สำหรับธุรกิจเริ่มต้นที่ต้องการระบบพื้นฐาน</div>
                  </div>
                  <div className="hpx-320 rounded-3 bg-secondary-light py-3 pe-3 mb-3">
                    <ul class="mb-0 text-start text-12 list-unstyled mx-2">
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>วิเคราะห์ระบบเบื้องต้น</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>Landing Page หรือ Web Application เริ่มต้น</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>UX/UI Design มาตรฐาน</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>Responsive Design (มือถือ/แท็บเล็ต)</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>Hosting + Domain 1 ปี</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>Support 1 เดือน</span></li>
                    </ul>
                  </div>
                  <button
                    className="btn btn-primary w-100"
                    onClick={() => {
                      this.Submit("Starter", 25000);
                    }}
                  >
                    ติดต่อสอบถาม
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-6 col-xl-3 mb-3 p-1">
                <div className="card card-dashboard mx-auto bg-white rounded-4 bg-white p-4">
                  <div className="text-center">
                  <h5 className="fw-bold text-success">Growth</h5>
                  <h2 className="fw-bold mb-0 mx-2 mb-2">85,000</h2>
                  <div className="mb-2 hpx-50 text-14 text-secondary">รองรับการเติบโตของธุรกิจ พร้อมเชื่อมต่อระบบภายใน</div>
                  </div>
                  <div className="hpx-320 rounded-3 bg-secondary-light py-3 pe-3 mb-3">
                    <ul class="mb-0 text-start text-12 list-unstyled mx-2">
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>วิเคราะห์กระบวนการธุรกิจ</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>Web App หรือ Mobile App (React / Flutter)</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>Dashboard / Back Office</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>UX/UI Design ตามพฤติกรรมผู้ใช้</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>เชื่อมต่อ API ภายนอก (เช่น Line OA, Payment, CRM)</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>Hosting พร้อม DevOps พื้นฐาน</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>Support 3 เดือน</span></li>
                    </ul>
                  </div>
                  <button
                    className="btn btn-primary w-100"
                    onClick={() => {
                      this.Submit("Growth", 85000);
                    }}
                  >
                    ติดต่อสอบถาม
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-6 col-xl-3 mb-3 p-1">
                <div className="card card-dashboard mx-auto bg-white rounded-4 bg-white p-4">
                  <div className="text-center">
                  <h5 className="fw-bold text-warning">Enterprise</h5>
                  <h2 className="fw-bold mb-0 mx-2 mb-2">250,000</h2>
                  <div className="mb-2 hpx-50 text-14 text-secondary">ระบบระดับองค์กร ครบทุกฟังก์ชัน + ความปลอดภัยสูง</div>
                  </div>
                  <div className="hpx-320 rounded-3 bg-secondary-light py-3 pe-3 mb-3">
                    <ul class="mb-0 text-start text-12 list-unstyled mx-2">
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>วิเคราะห์เชิงลึก + วางแผนเทคโนโลยีร่วมกับทีมผู้บริหาร</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>ERP / CRM / POS / IoT Platform</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>Mobile & Web Application แบบ Custom</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>DevOps, Docker, Kubernetes, CI/CD</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>วางระบบ Cloud (AWS, GCP, Azure)</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>Logging, Monitoring, Backup ครบวงจร</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>Pen Test / Security Scan</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>อบรมทีมงาน + เอกสารระบบ</span></li>
                    </ul>
                  </div>
                  <button
                    className="btn btn-primary w-100"
                    onClick={() => {
                      this.Submit("Enterprise", 250000);
                    }}
                  >
                    ติดต่อสอบถาม
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-6 col-xl-3 mb-3 p-1">
                <div className="card card-dashboard mx-auto bg-white rounded-4 bg-white p-4">
                  <div className="text-center">
                  <h5 className="fw-bold text-info">Custom</h5>
                  <h2 className="fw-bold mb-0 mx-2 mb-2">ตามโครงการ</h2>
                  <div className="mb-2 hpx-50 text-14 text-secondary">โซลูชันเฉพาะทาง ออกแบบตามความต้องการของคุณ</div>
                  </div>
                  <div className="hpx-320 rounded-3 bg-secondary-light py-3 pe-3 mb-3">
                    <ul class="mb-0 text-start text-12 list-unstyled mx-2">
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>วิเคราะห์กลยุทธ์องค์กรร่วมกับผู้บริหาร</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>ออกแบบสถาปัตยกรรมระบบ (Architecture Design)</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>ทำ Prototype, Test ระบบตามเงื่อนไข</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>จัดทำ Technical Spec / TOR</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>พัฒนาระบบร่วมกับหลายฝ่าย (Dev Team / IT / Security)</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>บริการระยะยาว / Maintenance ตาม SLA</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>Support การเสนอแผน (เช่น เสนอผู้บริหาร, นำเสนอผู้ลงทุน)</span></li>
                    </ul>
                  </div>
                  <button
                    className="btn btn-primary w-100"
                    onClick={() => {
                      this.Submit("Custom", 0);
                    }}
                  >
                    ติดต่อสอบถาม
                  </button>
                </div>
              </div>
            </div>
          )}
          {package_type === "month" && (
            <div className="row container mx-auto justify-content-center">
              <div className="col-12 col-md-6 col-xl-3 mb-3 p-1">
                <div className="card card-dashboard mx-auto bg-white rounded-4 bg-white p-4">
                  <div className="text-center">
                  <h5 className="fw-bold">Basic Care</h5>
                    <h2 className="fw-bold mb-0 mx-2 mb-2">1,500</h2>
                  <div className="mb-2 hpx-50 text-14 text-secondary">สำหรับธุรกิจขนาดเล็กที่ต้องการดูแลระบบพื้นฐานอย่างต่อเนื่อง</div>
                  </div>
                  <div className="hpx-320 rounded-3 bg-secondary-light py-3 pe-3 mb-3">
                    <ul class="mb-0 text-start text-12 list-unstyled mx-2">
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>ดูแล Server/Hosting</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>Backup ข้อมูลรายสัปดาห์</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>แก้ไขบั๊กเล็กน้อย (ไม่เกิน 1 ชั่วโมง/เดือน)</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>ตรวจสอบการทำงานเบื้องต้นทุกเดือน</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>Email/Chat Support (เวลาทำการ)</span></li>
                    </ul>
                  </div>
                  <button
                    className="btn btn-primary w-100"
                    onClick={() => {
                      this.Submit("Basic Care", 1500);
                    }}
                  >
                    ติดต่อสอบถาม
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-6 col-xl-3 mb-3 p-1">
                <div className="card card-dashboard mx-auto bg-white rounded-4 bg-white p-4">
                  <div className="text-center">
                  <h5 className="fw-bold text-success">Business Care</h5>
                    <h2 className="fw-bold mb-0 mx-2 mb-2">5,500</h2>
                  <div className="mb-2 hpx-50 text-14 text-secondary">สำหรับธุรกิจที่ต้องการความมั่นใจมากขึ้นในการใช้งานระบบ</div>
                  </div>
                  <div className="hpx-320 rounded-3 bg-secondary-light py-3 pe-3 mb-3">
                    <ul class="mb-0 text-start text-12 list-unstyled mx-2">
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>ดูแล Server (Cloud, VPS)</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>Backup รายวัน + Monitor uptime</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>แก้ไขบั๊ก/ปรับปรุง UI (ไม่เกิน 4 ชั่วโมง/เดือน)</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>Monthly Report การทำงานของระบบ</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>Priority Email/Chat Support</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>ปรับปรุงฟีเจอร์เล็กน้อยตามตกลง</span></li>
                    </ul>
                  </div>
                  <button
                    className="btn btn-primary w-100"
                    onClick={() => {
                      this.Submit("Business Care", 5500);
                    }}
                  >
                    ติดต่อสอบถาม
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-6 col-xl-3 mb-3 p-1">
                <div className="card card-dashboard mx-auto bg-white rounded-4 bg-white p-4">
                  <div className="text-center">
                  <h5 className="fw-bold text-warning">Enterprise Care</h5>
                    <h2 className="fw-bold mb-0 mx-2 mb-2">15,000</h2>
                  <div className="mb-2 hpx-50 text-14 text-secondary">สำหรับองค์กรที่ต้องการความต่อเนื่อง ความปลอดภัย และ SLA ที่ชัดเจน</div>
                  </div>
                  <div className="hpx-320 rounded-3 bg-secondary-light py-3 pe-3 mb-3">
                    <ul class="mb-0 text-start text-12 list-unstyled mx-2">
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>ดูแลระบบ Infrastructure (Cloud / Docker / CI/CD)</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>Monitor 24/7 พร้อมแจ้งเตือน</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>Backup แบบ Offsite + DR Plan</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>ปรับปรุงระบบ แก้ไขบั๊ก + Update Security Patch (สูงสุด 12 ชม./เดือน)</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>Pen Test/Scan ทุกไตรมาส (ถ้ามีสัญญา ≥ 6 เดือน)</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>ประสานงานกับทีมในองค์กร (เช่น ฝ่าย IT หรือ Compliance)</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>ช่องทางติดต่อเฉพาะ (Line, Slack, Call)</span></li>
                    </ul>
                  </div>
                  <button
                    className="btn btn-primary w-100"
                    onClick={() => {
                      this.Submit("Enterprise Care", 15000);
                    }}
                  >
                    ติดต่อสอบถาม
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-6 col-xl-3 mb-3 p-1">
                <div className="card card-dashboard mx-auto bg-white rounded-4 bg-white p-4">
                  <div className="text-center">
                  <h5 className="fw-bold text-info">Custom Enterprise</h5>
                    <h2 className="fw-bold mb-0 mx-2 mb-2">ตามโครงการ</h2>
                  <div className="mb-2 hpx-50 text-14 text-secondary">ราคาและขอบเขตขึ้นอยู่กับการวิเคราะห์ความต้องการ</div>
                  </div>
                  <div className="hpx-320 rounded-3 bg-secondary-light py-3 pe-3 mb-3">
                    <ul class="mb-0 text-start text-12 list-unstyled mx-2">
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>SLA การตอบกลับใน 1–4 ชั่วโมง</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>DevOps ทีมเฉพาะประจำระบบ</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>การดูแล Container / Kubernetes</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>ปรับแต่งระบบตาม compliance (เช่น PDPA, ISO 27001)</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>ระบบสำรองข้อมูลแบบ Redundant / Multizone</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>เชื่อมต่อกับระบบเดิมขององค์กร (เช่น SAP, Salesforce)</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>จัดฝึกอบรมให้กับพนักงานฝ่าย IT หรือ Support</span></li>
                      <li className="mb-2 d-flex"><span className="icon me-1 text-primary">{"\uf00c"}</span><span>การประเมินและวางระบบ Disaster Recovery แบบองค์กร</span></li>
                    </ul>
                  </div>
                  <button
                    className="btn btn-primary w-100"
                    onClick={() => {
                      this.Submit("Custom Enterprise", 0);
                    }}
                  >
                    ติดต่อสอบถาม
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* SECTION 3 */}
        <div className="w-100 bg-gray align-content-center">
          <div className="row container mx-auto my-5 justify-content-center">
            <div className="col-12 col-md-6 col-xl-4 mb-3">
              <div className="card card-dashboard px-2 py-4 bg-white h-100">
              <div className="px-4 mx-auto text-center">
                <img alt="LOGO" src="https://cdn-icons-png.flaticon.com/512/7863/7863923.png" className="mb-3" width="50" height="50" style={{ objectFit: "cover" }} />
                <h4 className="fw-bold mb-4 hpx-50 text-center">วิเคราะห์ระบบและให้คำปรึกษาธุรกิจ</h4>
                <div className="mb-2 text-secondary text-14 hpx-70">Business Analysis & Technology Consulting เราช่วยคุณวางรากฐานเทคโนโลยีที่แข็งแรงและตอบโจทย์ธุรกิจ</div>
                <ul class="mb-0 text-start text-14">
                  <li>วิเคราะห์กระบวนการทำงานขององค์กร</li>
                  <li>ออกแบบระบบให้ตอบโจทย์กลยุทธ์ธุรกิจ</li>
                  <li>แนะนำเทคโนโลยีให้เหมาะสมกับเป้าหมาย</li>
                </ul>
              </div></div>
            </div>
            <div className="col-12 col-md-6 col-xl-4 mb-3">
              <div className="card card-dashboard px-2 py-4 bg-white h-100">
              <div className="px-4 mx-auto text-center">
                <img alt="LOGO" src="https://cdn-icons-png.flaticon.com/512/12119/12119985.png" className="mb-3" width="50" height="50" style={{ objectFit: "cover" }} />
                <h4 className="fw-bold mb-4 hpx-50 text-center">UX/UI Design</h4>
                <div className="mb-2 text-secondary text-14 hpx-70">ออกแบบประสบการณ์ใช้งาน และส่วนติดต่อผู้ใช้ สร้างความประทับใจแรก และเพิ่มประสิทธิภาพการใช้งาน</div>
                <ul class="mb-0 text-start text-14">
                  <li>ออกแบบ Interface ที่ใช้งานง่ายและสวยงาม</li>
                  <li>เน้นประสบการณ์ผู้ใช้งาน (UX)</li>
                  <li>รองรับทั้ง Web และ Mobile</li>
                </ul>
              </div></div>
            </div>
            <div className="col-12 col-md-6 col-xl-4 mb-3">
              <div className="card card-dashboard px-2 py-4 bg-white h-100">
              <div className="px-4 mx-auto text-center">
                <img alt="LOGO" src="https://cdn-icons-png.flaticon.com/512/10853/10853313.png" className="mb-3" width="50" height="50" style={{ objectFit: "cover" }} />
                <h4 className="fw-bold mb-4 hpx-50 text-center">พัฒนา Web Application & Mobile Application</h4>
                <div className="mb-2 text-secondary text-14 hpx-70">Modern Development with Scalable Architecture เราพัฒนาแอปพลิเคชันที่รองรับการเติบโตของธุรกิจ</div>
                <ul class="mb-0 text-start text-14">
                  <li>พัฒนาเว็บแอปที่ปรับขยายได้</li>
                  <li>แอปมือถือ iOS / Android</li>
                  <li>ใช้เทคโนโลยีสมัยใหม่ เช่น React, Node.js, Flutter</li>
                </ul>
              </div></div>
            </div>
            <div className="col-12 col-md-6 col-xl-4 mb-3">
              <div className="card card-dashboard px-2 py-4 bg-white h-100">
              <div className="px-4 mx-auto text-center">
                <img alt="LOGO" src="https://cdn-icons-png.flaticon.com/512/12756/12756030.png" className="mb-3" width="50" height="50" style={{ objectFit: "cover" }} />
                <h4 className="fw-bold mb-4 hpx-50 text-center">ระบบ POS และ IoT</h4>
                <div className="mb-2 text-secondary text-14 hpx-70">ระบบจัดการหน้าร้าน + อุปกรณ์อัจฉริยะ เหมาะกับธุรกิจที่ต้องการระบบที่เชื่อมโยงกับโลกจริง</div>
                <ul class="mb-0 text-start text-14">
                  <li>ระบบหน้าร้าน คลังสินค้า การขาย</li>
                  <li>ระบบ IoT เชื่อมต่อ Cloud</li>
                  <li>ออกแบบทั้ง Hardware และ Software</li>
                </ul>
              </div></div>
            </div>
            <div className="col-12 col-md-6 col-xl-4 mb-3">
              <div className="card card-dashboard px-2 py-4 bg-white h-100">
              <div className="px-4 mx-auto text-center">
                <img alt="LOGO" src="https://cdn-icons-png.flaticon.com/512/1670/1670384.png" className="mb-3" width="50" height="50" style={{ objectFit: "cover" }} />
                <h4 className="fw-bold mb-4 hpx-50 text-center">ระบบ ERP / CRM</h4>
                <div className="mb-2 text-secondary text-14 hpx-70">เพิ่มประสิทธิภาพการบริหารภายในองค์กร ยกระดับองค์กรด้วยระบบที่ช่วยบริหารจัดการแบบรวมศูนย์</div>
                <ul class="mb-0 text-start text-14">
                  <li>บริหารทรัพยากรองค์กรแบบครบวงจร</li>
                  <li>ระบบบริหารลูกค้าสัมพันธ์</li>
                  <li>ปรับแต่งตามกระบวนการของแต่ละองค์กร</li>
                </ul>
              </div></div>
            </div>
            <div className="col-12 col-md-6 col-xl-4 mb-3">
              <div className="card card-dashboard px-2 py-4 bg-white h-100">
              <div className="px-4 mx-auto text-center">
                <img alt="LOGO" src="https://cdn-icons-png.flaticon.com/512/11514/11514775.png" className="mb-3" width="50" height="50" style={{ objectFit: "cover" }} />
                <h4 className="fw-bold mb-4 hpx-50 text-center">DevOps, Cloud Infrastructure & Data</h4>
                <div className="mb-2 text-secondary text-14 hpx-70">โครงสร้างพื้นฐานที่มั่นคงและปรับขยายได้ เราวางระบบให้พร้อมรองรับโหลดสูงและใช้งานได้ต่อเนื่อง</div>
                <ul class="mb-0 text-start text-14">
                  <li>วางระบบ Cloud บน AWS / Azure / GCP</li>
                  <li>ใช้ Docker / Kubernetes / CI-CD</li>
                  <li>บริการ Monitoring / Logging / Backup</li>
                </ul>
              </div></div>
            </div>
            <div className="col-12 col-md-6 col-xl-4 mb-3">
              <div className="card card-dashboard px-2 py-4 bg-white h-100">
              <div className="px-4 mx-auto text-center">
                <img alt="LOGO" src="https://cdn-icons-png.flaticon.com/128/179/179579.png" className="mb-3" width="50" height="50" style={{ objectFit: "cover" }} />
                <h4 className="fw-bold mb-4 hpx-50 text-center">Security & Compliance</h4>
                <div className="mb-2 text-secondary text-14 hpx-70">มั่นใจในความปลอดภัย และความเป็นส่วนตัว ความปลอดภัยของข้อมูลและระบบ คือพื้นฐานที่เราคำนึงถึง</div>
                <ul class="mb-0 text-start text-14">
                  <li>ตรวจสอบความปลอดภัยระบบ (Pen Test)</li>
                  <li>วางระบบตามมาตรฐาน PDPA / GDPR / ISO</li>
                  <li>ให้คำปรึกษาด้าน Data Privacy</li>
                </ul>
              </div></div>
            </div>
            <div className="col-12 col-md-6 col-xl-4 mb-3">
              <div className="card card-dashboard px-2 py-4 bg-white h-100">
              <div className="px-4 mx-auto text-center">
                <img alt="LOGO" src="https://cdn-icons-png.flaticon.com/512/14262/14262819.png" className="mb-3" width="50" height="50" style={{ objectFit: "cover" }} />
                <h4 className="fw-bold mb-4 hpx-50 text-center">บริการเสริม (Add-on Services)</h4>
                <div className="mb-2 text-secondary text-14 hpx-70">เพิ่มความสมบูรณ์ให้ระบบ และลดภาระทีมงานของคุณ</div>
                <ul class="mb-0 text-start text-14">
                  <li>จัดทำเอกสารระบบ</li>
                  <li>ฝึกอบรมทีมงาน</li>
                  <li>บริการดูแลระบบและซัพพอร์ตรายเดือน</li>
                </ul>
              </div>
            </div></div>
          </div>
        </div>

        {/* SECTION 4 */}
        <div className="bg-white py-4">
        <div className="container px-4 mx-auto text-center">
          <div className="mb-4">เราใช้กรอบการทำงานการพัฒนาซอฟต์แวร์ล่าสุดเพื่อนำเสนอโซลูชันที่ทันสมัยตามความต้องการเฉพาะของคุณ</div>
          <div className="row">
            <div className="col-6 col-sm-4 col-md-3 col-xl-2 mb-4">
              <img src="https://sevenpeakssoftware.com/hubfs/Seven%20Peaks%20Assets/Technology%20Brands/kubernates.svg" alt="kubernates" width="136" height="56" />
            </div>
            <div className="col-6 col-sm-4 col-md-3 col-xl-2 mb-4">
              <img src="https://sevenpeakssoftware.com/hubfs/Seven%20Peaks%20Assets/Technology%20Brands/net.svg" alt="net" width="136" height="56" />
            </div>
            <div className="col-6 col-sm-4 col-md-3 col-xl-2 mb-4">
              <img src="https://sevenpeakssoftware.com/hubfs/Seven%20Peaks%20Assets/Technology%20Brands/terraform.svg" alt="terraform" width="136" height="56" />
            </div>
            <div className="col-6 col-sm-4 col-md-3 col-xl-2 mb-4">
              <img src="https://sevenpeakssoftware.com/hubfs/Seven%20Peaks%20Assets/Technology%20Brands/swift.svg" alt="swift" width="136" height="56" />
            </div>
            <div className="col-6 col-sm-4 col-md-3 col-xl-2 mb-4">
              <img src="https://sevenpeakssoftware.com/hubfs/Seven%20Peaks%20Assets/Technology%20Brands/kotlin.svg" alt="kotlin" width="136" height="56" />
            </div>
            <div className="col-6 col-sm-4 col-md-3 col-xl-2 mb-4">
              <img src="https://sevenpeakssoftware.com/hubfs/Seven%20Peaks%20Assets/Technology%20Brands/node.svg" alt="node" width="136" height="56" />
            </div>
            <div className="col-6 col-sm-4 col-md-3 col-xl-2 mb-4">
              <img src="https://sevenpeakssoftware.com/hubfs/Seven%20Peaks%20Assets/Technology%20Brands/jmeter.svg" alt="jmeter" width="136" height="56" />
            </div>
            <div className="col-6 col-sm-4 col-md-3 col-xl-2 mb-4">
              <img src="https://sevenpeakssoftware.com/hubfs/Seven%20Peaks%20Assets/Technology%20Brands/firebase.svg" alt="firebase" width="136" height="56" />
            </div>
            <div className="col-6 col-sm-4 col-md-3 col-xl-2 mb-4">
              <img src="https://sevenpeakssoftware.com/hubfs/Seven%20Peaks%20Assets/Technology%20Brands/cypress.svg" alt="cypress" width="136" height="56" />
            </div>
            <div className="col-6 col-sm-4 col-md-3 col-xl-2 mb-4">
              <img src="https://sevenpeakssoftware.com/hubfs/Seven%20Peaks%20Assets/Technology%20Brands/google.svg" alt="google" width="136" height="56" />
            </div>
            <div className="col-6 col-sm-4 col-md-3 col-xl-2 mb-4">
              <img src="https://sevenpeakssoftware.com/hubfs/Seven%20Peaks%20Assets/Technology%20Brands/react.svg" alt="react" width="136" height="56" />
            </div>
            <div className="col-6 col-sm-4 col-md-3 col-xl-2 mb-4">
              <img src="https://sevenpeakssoftware.com/hubfs/Seven%20Peaks%20Assets/Technology%20Brands/azure.svg" alt="azure" width="136" height="56" />
            </div>
          </div>
        </div>
        </div>

        {/* SECTION 5 */}
        <div className="w-100 bg-blue text-white">
          <div className="container mx-auto px-4 py-5">
            <div className="my-5 text-center">
              <h1 className="fw-bold mb-4">ปรึกษาเราฟรีวันนี้</h1>
              <div className="mb-3">เราพร้อมรับฟังความต้องการของคุณ วิเคราะห์ปัญหาอย่างตรงจุด และเสนอแนวทางที่เหมาะสมกับองค์กรของคุณมากที่สุด</div>
              <div className="mb-4">ให้เทคโนโลยีขับเคลื่อนธุรกิจของคุณ — ไปพร้อมกับเรา</div>
              <a className="btn btn-light px-5" href="/contact">
                ติดต่อเรา
              </a>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
